import { TYPES } from 'action-types/historyLog';
import {
	IHistoryLogModel, IHistoryCostAndRevenueLogModel
} from 'reducers/historyLog/models';
import { IResultWithPagination } from 'reducers/models';
import * as msgs from '../../constants/validationMessages';

export interface ICostAndRevenue extends IResultWithPagination<IHistoryCostAndRevenueLogModel> { }

export interface IHistoryLogAction {
	readonly type: string;
	readonly error?: string;
	readonly response: IHistoryLogModel;
	readonly costAndRevenue: ICostAndRevenue;
	readonly blob: any;
	readonly outputBlob: any;
	readonly outputFileName: string;
}

export interface IHistoryLogState {
	readonly isFetchDataLoading: boolean;
	readonly isFetchDataError: boolean;
	readonly pendingError: string | string[];
	readonly response: any;
	readonly costAndRevenue: ICostAndRevenue;
	readonly isFetchDataLoadingCV: boolean;
	readonly isFetchDataErrorCV: boolean;
	readonly pendingErrorCV: string | string[];
	readonly blobLoading: boolean;
	readonly blob: any;
	readonly blobError: string;
	readonly outputBlob: any;
	readonly outputFileName: string;
}

export const defaultState: IHistoryLogState = {
	isFetchDataError: false,
	pendingError: '',
	isFetchDataLoading: false,
	isFetchDataErrorCV: false,
	pendingErrorCV: '',
	isFetchDataLoadingCV: false,
	response: [],
	blob: null,
	blobError: '',
	blobLoading: false,
	costAndRevenue: {
		pageNumber: 1,
		pageSize: 0,
		result: [],
		totalCount: 0
	},
	outputBlob: null,
	outputFileName: ''
};

export const reducer = (state: IHistoryLogState = defaultState, action: IHistoryLogAction): IHistoryLogState => {
	switch (action.type) {
		case TYPES.FETCH_HISTORY_LOG.PENDING:
			return {
				...state,
				isFetchDataLoading: true,
				isFetchDataError: false,
				pendingError: ''
			};
		case TYPES.FETCH_HISTORY_LOG.FULFILLED:
			return {
				...state,
				response: action.response,
				isFetchDataLoading: false,
				isFetchDataError: false,
				pendingError: ''
			};
		case TYPES.FETCH_HISTORY_LOG.REJECTED:
			return {
				...state,
				response: [],
				isFetchDataLoading: false,
				isFetchDataError: true,
				pendingError: action.error ? action.error : msgs.HistoryLog.Error_message
			};
		case TYPES.FETCH_HISTORY_CV_LOG.PENDING:
			return {
				...state,
				isFetchDataLoadingCV: true,
				isFetchDataErrorCV: false,
				pendingErrorCV: ''
			};
		case TYPES.FETCH_HISTORY_CV_LOG.FULFILLED:
			return {
				...state,
				costAndRevenue: action.costAndRevenue,
				isFetchDataLoadingCV: false,
				isFetchDataErrorCV: false,
				pendingErrorCV: ''
			};
		case TYPES.FETCH_HISTORY_CV_LOG.REJECTED:
			return {
				...state,
				isFetchDataLoadingCV: false,
				isFetchDataErrorCV: true,
				costAndRevenue: defaultState.costAndRevenue,
				pendingErrorCV: action.error ? action.error : msgs.HistoryLog.PendingErrorCV
			};
		case TYPES.FETCH_HISTORY_BLOB.PENDING:
			return {
				...state,
				blobLoading: true,
				blobError: ''
			};
		case TYPES.FETCH_HISTORY_BLOB.FULFILLED:
			return {
				...state,
				blobLoading: false,
				blob: action.blob,
				blobError: ''
			};
		case TYPES.FETCH_HISTORY_BLOB.REJECTED:
			return {
				...state,
				blobLoading: false,
				blobError: action.error ? action.error : 'Could not fetch the Blob'
			};
		case TYPES.FETCH_OUTPUT_FILE.PENDING:
			return {
				...state,
				blobLoading: true,
				outputBlob: null,
				outputFileName: '',
				blobError: ''
			};
		case TYPES.FETCH_OUTPUT_FILE.FULFILLED:
			return {
				...state,
				blobLoading: false,
				outputBlob: action.outputBlob,
				outputFileName: action.outputFileName,
				blobError: ''
			};
		case TYPES.FETCH_OUTPUT_FILE.REJECTED:
			return {
				...state,
				blobLoading: false,
				outputBlob: null,
				outputFileName: '',
				blobError: action.error ? action.error : 'Could not fetch the Blob'
			};
		default:
			return state;
	}
};
